import { render, staticRenderFns } from "./DialogId4.vue?vue&type=template&id=88a55a80&scoped=true&"
import script from "./DialogId4.vue?vue&type=script&lang=js&"
export * from "./DialogId4.vue?vue&type=script&lang=js&"
import style0 from "./DialogId4.vue?vue&type=style&index=0&id=88a55a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a55a80",
  null
  
)

export default component.exports